import { createContext, useContext, useState, useCallback } from 'react';

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const addCompany = useCallback((realm) => {
    setSelectedCompanies(prev => {
      if (prev.find(c => c.rf_id === realm.rf_id)) return prev;
      return [...prev, realm];
    });
  }, []);

  const removeCompany = useCallback((rfId) => {
    setSelectedCompanies(prev => prev.filter(c => c.rf_id !== rfId));
  }, []);

  const rfIds = selectedCompanies.map(c => c.rf_id);

  return (
    <CompanyContext.Provider value={{ selectedCompanies, addCompany, removeCompany, setCompanies: setSelectedCompanies, rfIds }}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const ctx = useContext(CompanyContext);
  if (!ctx) throw new Error('useCompany must be used within CompanyProvider');
  return ctx;
}
